import Vue from "vue";
import Router from "vue-router";
import Profile from "./views/Profile.vue";
import List from "./views/List.vue";
import Chat from "./views/Chat.vue";
import LeadDetail from "./views/LeadDetail.vue";
import Detail from "./views/Detail.vue";
import Excel from "./views/Excel.vue";
import Task from "./views/Task.vue";
import ReportUtm from "./views/ReportUtm.vue";
import ReportMonthly from "./views/ReportMonthly.vue";
import ReportAgent from "./views/ReportAgent.vue";
import Dashboard from "./views/Dashboard.vue";
import Edit from "./views/Edit.vue";
import Login from "./views/Login.vue";
import ViqqaCallback from "./views/ViqqaCallback.vue";
import Logout from "./views/Logout.vue";
import CallPeriod from "./views/CallPeriod.vue";
import UserPermissions from "./views/UserPermissions.vue";
import AuthService from "./services/auth";
import Hooks from "./views/Hook.vue";
import Bids from "./views/Bid.vue";
import BidDetail from "./views/BidDetail.vue";
import Admin from "./views/Admin.vue";
import AdminDashboard from "./views/AdminDashboard.vue";
import AdminTimezone from "./views/AdminTimezone.vue";
import AdminInfo from "./views/AdminInfo.vue";
import QuizBuilder from "./views/QuizBuilder.vue";
import NotFound from "./views/NotFound.vue";
import Transactions from "./views/Transactions.vue";
import Reports from "./views/Reports.vue";
import ImportReport from "./views/ImportReport.vue";
import PieFirstFundReport from "./views/PieFirstFundReport.vue";
import FundingReport from "./views/FundingReport.vue";
import RetentionSalesReport from "./views/RetentionSalesReport.vue";
import HealthScore from "./views/HealthScore.vue";
import LeadStatusChangesReport from "./views/LeadStatusChangesReport.vue";
import DuplicateLeadsReport from "./views/DuplicateLeadsReport.vue";
import SourcePerformanceReport from "./views/SourcePerformanceReport.vue";
import AgentSourceMatrixReport from "./views/AgentSourceMatrixReport.vue";
import IdleLeadsReport from "./views/IdleLeadsReport.vue";
import ExportLogs from "./views/ExportLogs.vue";
import ExcelBulkFixer from "./views/ExcelBulkFixer.vue";
import AdminFieldManager from "./views/AdminFieldManager.vue";
import AdminReportCategories from "./views/AdminReportCategories.vue";
import AdminApiKeys from "./views/AdminApiKeys.vue";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        requiresAuth: false,
      },
    },
    {
      // Viqqa OAuth dönüşü (VIQQA_REDIRECT_URI). /login gibi herkese açık.
      path: "/auth/viqqa/callback",
      name: "viqqa-callback",
      component: ViqqaCallback,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/notfound",
      name: "NotFound",
      component: NotFound,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/logout",
      name: "logout",
      component: Logout,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/tasks",
      name: "tasks",
      component: Task,
      meta: {
        requiresAuth: true,
        location: 1,
      },
    },
    {
      path: "/call-periods",
      name: "call-periods",
      component: CallPeriod,
      meta: {
        requiresAuth: true,
        location: 1,
      },
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },  {
      path: "/piechart/firstFund",
      name: "PieFirstFundReport",
      component: PieFirstFundReport,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/transactions",
      name: "transactions",
      component: Transactions,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reports",
      name: "reports",
      component: Reports,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/list/:table",
      name: "list",
      component: List,
      meta: {
        requiresAuth: true,
        location: 1,
      },
    },
    {
      path: "/chat",
      name: "chat",
      component: Chat,
      meta: {
        requiresAuth: true,
        location: 1,
      },
    },
    {
      path: "/chat/ch/:channel",
      name: "chat-channel",
      component: Chat,
      meta: {
        requiresAuth: true,
        location: 1,
      },
    },
    {
      path: "/excel/:table",
      name: "excel",
      component: Excel,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/user/permissions/:id",
      name: "UserPermissions",
      component: UserPermissions,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/detail/:table/:id",
      name: "detail",
      component: Detail,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/edit/:table/:id",
      name: "edit",
      component: Edit,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/admin",
      name: "admin",
      component: AdminDashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/admin/export-detail-logs",
      name: "export-detail-logs",
      component: ExportLogs,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/admin/timezone",
      name: "admin-timezone",
      component: AdminTimezone,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/admin/excel-bulk-fixer",
      name: "excel-bulk-fixer",
      component: ExcelBulkFixer,
      meta: {
        requiresAuth: true,
        allowedDepartments: ["admin", "admin1", "admin2"],
      },
    },
    {
      path: "/admin/field-manager",
      name: "admin-field-manager",
      component: AdminFieldManager,
      meta: {
        requiresAuth: true,
        allowedDepartments: ["admin", "admin1", "admin2"],
      },
    },
    {
      path: "/admin/api-keys",
      name: "admin-api-keys",
      component: AdminApiKeys,
      meta: {
        requiresAuth: true,
        allowedDepartments: ["admin", "admin1", "admin2"],
      },
    },
    {
      path: "/admin/report-categories",
      name: "adminReportCategories",
      component: AdminReportCategories,
      meta: {
        requiresAuth: true,
        allowedDepartments: ["admin", "admin1", "admin2"],
      },
    },
    {
      path: "/admin/info",
      name: "admin-info",
      component: AdminInfo,
      meta: {
        requiresAuth: true,
        allowedDepartments: ["admin", "admin2"],
      },
    },
    {
      path: "/admin/:table",
      name: "adminDetail",
      component: Admin,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/hooks",
      name: "hooks",
      component: Hooks,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/bids",
      name: "bids",
      component: Bids,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/bids/:lead_id/:id",
      name: "bids_detail",
      component: BidDetail,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/quizbuilder",
      name: "quizbuilder",
      component: QuizBuilder,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/leadDetail/:id",
      name: "leadDetail",
      component: LeadDetail,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/utm",
      name: "report/utm",
      component: ReportUtm,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/agent",
      name: "report/agent",
      component: ReportAgent,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/monthly",
      name: "report/monthly",
      component: ReportMonthly,
      meta: {
        requiresAuth: true,
      },
    },   {
      path: "/report/import",
      name: "report/import",
      component: ImportReport,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/funding",
      name: "report/funding",
      component: FundingReport,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/retention-report-sales",
      name: "report/retention-report-sales",
      component: RetentionSalesReport,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/lead-status-changes",
      name: "report/lead-status-changes",
      component: LeadStatusChangesReport,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/duplicate-leads",
      name: "report/duplicate-leads",
      component: DuplicateLeadsReport,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/source-performance",
      name: "report/source-performance",
      component: SourcePerformanceReport,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/agent-source-matrix",
      name: "report/agent-source-matrix",
      component: AgentSourceMatrixReport,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/idle-leads",
      name: "report/idle-leads",
      component: IdleLeadsReport,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/health-score",
      name: "report/health-score",
      component: HealthScore,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!localStorage.getItem("authToken")) {
      next({ path: "/login" });
    } else {
      AuthService.loginValidate()
        .then((resp) => {
          if (resp === false) {
            next({
              path: "/login",
              params: { nextUrl: to.fullPath },
            });
          } else {
            next();
          }
        })
        .catch((e) => {
          next({
            path: "/login",
            params: { nextUrl: to.fullPath },
          });
        });
    }
  } else {
    next();
  }
});

export default router;
